import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="web-push-notification"
export default class extends Controller {

  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }


  initialize() {
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

    if (standalone) {
      this.updateUrl = this.element.dataset.updateUrl
      this.declinedStatus = this.element.dataset.declinedStatus
      this.vapidPublicKey = this.element.dataset.vapidPublicKey

      Notification.requestPermission().then(response => {
        if (response === 'granted') {
          navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
            serviceWorkerRegistration.pushManager
              .subscribe({
                userVisibleOnly: true,
                applicationServerKey: this.vapidPublicKey,
              }).then(response => {
              this.make_request(response.toJSON())
                .then(response => {
                  if (!response.ok) { throw response; }
                }).catch(error => {
                console.error("error", error)
              });

            }).catch(error => {
              console.log(error)
            });
          })
        } else {
          console.log('not granted', response)
          this.make_request({ status: this.declinedStatus })
        }
      })
    }
  }

  make_request(body) {
    return fetch(this.updateUrl, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "Content-Type": "application/json"
      }
    })
  }
}


